export const jobTypeConstants = {
  DEPOSITION: 1,
  MEDICAL_APPOINTMENT: 2,
  EUO: 3,
  EBT: 4,
  SIMULTANEOUS: 5,
  TRANSLATION: 6
};

export const jobTypeOptions = [
  { value: jobTypeConstants.DEPOSITION, label: 'Deposition' },
  {
    value: jobTypeConstants.MEDICAL_APPOINTMENT,
    label: 'Medical Appointment (IME)'
  },
  { value: jobTypeConstants.EUO, label: 'EUO' },
  { value: jobTypeConstants.EBT, label: 'EBT' },
  { value: jobTypeConstants.SIMULTANEOUS, label: 'Simultaneous' },
  { value: jobTypeConstants.TRANSLATION, label: 'Translation' }
];



/** WEBPACK FOOTER **
 ** ./src/utils/job-types.js
 **/